/**
 * Decide el diseño de render de un documento (comprobante/orden) de forma
 * determinística por `design_version`. NUNCA devuelve 'lowcode' sin template
 * (si el fetch del template falló, cae a 'legacy' para no quedar sin PDF).
 * Documentos sin design_version (legacy implícito) → 'legacy'.
 *
 * @param {object|null} doc - Documento con campo design_version
 * @param {object|null} template - Plantilla lowcode (persistida o default)
 * @returns {'legacy'|'lowcode'}
 */
export function resolveDocDesign(doc, template) {
  if (!doc || doc.design_version !== 'lowcode') return 'legacy';
  if (!template) return 'legacy'; // guard: error de fetch del template
  return 'lowcode';
}
